// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 0,
  pageSize: 20,
  customFilters: [],
  value: "",
  sorting: [],
  sortField: "nom",
  sortOrder: "asc",
  activeTab: "details",
  //Nouveau
  query: "",
  actif: {},
  selectedOptionFilters: null,
  selectedOptionId: null,
  column: [],
};

const FiltreSouscriptions = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_SOUSCRIPTION:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_SOUSCRIPTION:
      return {
        ...state,
        currentPage: action.payload,
      };
    case actionTypes.SET_CUSTOM_FILTERS_SOUSCRIPTION:
      return {
        ...state,
        customFilters: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_SOUSCRIPTION:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_PAGE_SIZE_SOUSCRIPTION:
      return {
        ...state,
        pageSize: action.payload,
      };
    case actionTypes.SET_SORTING_SOUSCRIPTION:
      return {
        ...state,
        sorting: action.payload,
      };
    case actionTypes.SET_ORDER_SOUSCRIPTION:
      return {
        ...state,
        sortOrder: action.payload,
      };
    case actionTypes.SET_ACTIVE_TAB_SOUSCRIPTION:
      return {
        ...state,
        activeTab: action.payload,
      };
    case actionTypes.SET_QUERY_SOUSCRIPTION:
      return {
        ...state,
        query: action.payload,
      };
    case actionTypes.SET_ACTIF_SOUSCRIPTION:
      return {
        ...state,
        actif: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_FILTERS_SOUSCRIPTION:
      return {
        ...state,
        selectedOptionFilters: action.payload,
      };
    case actionTypes.SET_SELECTED_OPTION_ID_SOUSCRIPTION:
      return {
        ...state,
        selectedOptionId: action.payload,
      };
    case actionTypes.SET_COLUMN_SOUSCRIPTION:
      return {
        ...state,
        column: action.payload,
      };
    default:
      return state;
  }
};

export default FiltreSouscriptions;
